module.exports = __webpack_public_path__ + "static/logo50.16f0b3cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo50.jpg
// module id = 796
// module chunks = 79611799117203 84521481881339